import { isomorphicConfig } from '@utils/isomorphic_config';

const PRODUCTION_ACCOUNT_BASE_URL = 'https://account.clutter.com';
const PRODUCTION_CAREERS_BASE_URL = 'https://careers.clutter.com';

export const accountBaseUrl = (): string => {
  try {
    return isomorphicConfig().accountBaseUrl ?? PRODUCTION_ACCOUNT_BASE_URL;
  } catch {
    return PRODUCTION_ACCOUNT_BASE_URL;
  }
};

export const accountUrl = (path = ''): string => {
  const base = accountBaseUrl().replace(/\/$/, '');
  if (!path) {
    return base;
  }
  return `${base}/${path.replace(/^\//, '')}`;
};

export const careersBaseUrl = (): string => {
  try {
    return isomorphicConfig().careersBaseUrl ?? PRODUCTION_CAREERS_BASE_URL;
  } catch {
    return PRODUCTION_CAREERS_BASE_URL;
  }
};
